import { Text } from '@chakra-ui/react'

import type { FormBlock, FormValues } from '@/components/UI/Form/types'

import { DATA_CONSENT_INPUT_NAME, type LearningLabsConsentDetails } from './constants'

// When you update `LearningLabsConsentFormInputs`, you may also need to update this function to parse it into an understandable schema
export function getLearningLabsConsentResponses(
  formValues: FormValues
): LearningLabsConsentDetails {
  return {
    acknowledgements: [DATA_CONSENT_INPUT_NAME].filter(value => value in formValues),
  }
}

export function getLearningLabsConsentFormInputs(): FormBlock[] {
  const dataConsent: FormBlock = {
    type: 'multi-checkbox',
    name: DATA_CONSENT_INPUT_NAME,
    label: 'Data Sharing',
    sublabel: (
      <Text>
        As a part of this program, we may share some of this learning lab data (e.g., survey
        results, recordings, etc.) with Khan Academy to improve the quality of this tutoring
        program. Khan Academy may also share aggregated and/or de-identified survey data and other
        data with donors and other partner institutions to encourage the ongoing development of the
        Learning Labs program.
      </Text>
    ),
    options: [
      {
        label: 'I acknowledge that some of my Schoolhouse data may be shared with Khan Academy',
        value: `${DATA_CONSENT_INPUT_NAME}-yes`,
      },
    ],
    required: true,
    size: 6,
  }

  return [dataConsent]
}
